// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      wm-difficulty {
        > div {
          height: 100%;
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 20px;
          font-weight: 700;
          color: var(--ion-text-color);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          .bullet {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            border: 1px solid var(--wm-color-primary);

            &.fill {
              background-color: var(--wm-color-primary);
            }
          }
        }
      }
    `, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/difficulty/difficulty.component.ts"],"names":[],"mappings":";MACM;QACE;UACE,YAAY;UACZ,aAAa;UACb,mBAAmB;UACnB,QAAQ;UACR,eAAe;UACf,gBAAgB;UAChB,4BAA4B;UAC5B,mBAAmB;UACnB,gBAAgB;UAChB,uBAAuB;;UAEvB;YACE,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,yCAAyC;;YAEzC;cACE,yCAAyC;YAC3C;UACF;QACF;MACF","sourcesContent":["\n      wm-difficulty {\n        > div {\n          height: 100%;\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          font-size: 20px;\n          font-weight: 700;\n          color: var(--ion-text-color);\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n\n          .bullet {\n            width: 20px;\n            height: 20px;\n            border-radius: 50%;\n            border: 1px solid var(--wm-color-primary);\n\n            &.fill {\n              background-color: var(--wm-color-primary);\n            }\n          }\n        }\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
